import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'

Vue.use(Vuex)

export default {
	state: {
		list: [],
	},
	mutations: {
		[MUTATIONS.CATEGORY.CREATE](state, category) {
			if (category.isMainCategory) {
				state.list.main.push(category)
			} else {
				state.list.sub.push(category)
			}
		},
		[MUTATIONS.CATEGORY.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.CATEGORY.DELETE](state, id) {
			let categorySub = state.list.sub.find(c => {
				return c.id === id
			})
			if (categorySub) {
				state.list.sub.splice(state.list.sub.indexOf(categorySub), 1)
			}
			let categoryMain = state.list.main.find(c => {
				return c.id === id
			})
			if (categoryMain) {
				state.list.main.splice(state.list.main.indexOf(categoryMain), 1)
			}
		},
	},
	actions: {
		[ACTIONS.CATEGORY.LIST]({ commit, dispatch, state }, filter = {}) {
			return API.CATEGORY.LIST(filter).then(res => {
				commit(MUTATIONS.CATEGORY.LIST, res)
				return res
			})
		},
		[ACTIONS.CATEGORY.CREATE](
			{ commit, dispatch, state },
			{ code, isMainCategory, orgId },
		) {
			return API.CATEGORY.CREATE({ code, isMainCategory, orgId }).then(res => {
				commit(MUTATIONS.CATEGORY.CREATE, res)
				return res
			})
		},

		[ACTIONS.CATEGORY.DELETE]({ commit, dispatch, state }, { id }) {
			return API.CATEGORY.DELETE(id).then(res => {
				commit(MUTATIONS.CATEGORY.DELETE, id)
				return res
			})
		},
	},

	getters: {
		getCategoryList: state => state.list,
	},
}
